var $ = require('jquery');
window.jQuery = $;
window.$ = window.jQuery;

var RNStorage = require('_utils/storage');

require('./vendor/bootstrap-datepicker.min');
require('./vendor/jquery-ui.min');

require('./polyfills/array.prototype.find');
require('./polyfills/array.prototype.some');

var ko = require('knockout');
require('knockout-postbox');

require('scrolltofixed');
require('dotdotdot');
require('jquery.cookie');
require('jquery.easing');
require('selectize');

window.regnskapnorge = {};

// Registers components manually.
// TODO: Whenever working with a feature that touches one of these components, remove it from register-components if possible and add an index.js file instead. For some components, this will require moving a template from a .cshtml file to a .template file.
require('../components/knockout/register-components');

// Generated file. Imports all index.js files from 'app/components/knockout'. Not all components have an index.js file because the people who worked on this project before preferred to have a manually maintained list of components (register-components.js).
require('./knockout-components');

require('../components/knockout/binding-handlers');
require('../components/knockout/extenders');

// Imports all javascript files from atoms, molecules and organisms folders, except for two component (below)
require('./atomic-components');

require('./toggle-content');

require('./enquire-init');
require('./error-tracking');

// Remove storage for filters in KK if the user is not logged in.
if (
  window.username === undefined ||
  window.username === null ||
  window.username.length === 0
) {
  RNStorage.removeItem('committeeFilters');
}

$('[data-scroll-trigger]').on('click', function(e) {
  e.preventDefault();
  var $this = $(this),
    $triggerVal = $this.data('scroll-trigger'),
    $target = $("[data-scroll-target='" + $triggerVal + "']"),
    $targetPos = $target.offset().top;

  animateScroll($targetPos);
});

function animateScroll(pos) {
  $('html, body').animate(
    {
      scrollTop: pos
    },
    500
  );
}

function popupHandler(triggerVal) {
  var $target = $("[data-popup-target='" + triggerVal + "']");
  var $overlay = $('.overlay-popup');

  if (!$target.hasClass('is-visible')) {
    $target.addClass('is-visible');
    $overlay.addClass('is-visible');
  } else {
    $target.removeClass('is-visible');
    $overlay.removeClass('is-visible');
  }
}
//toggle mobile menu
$('[data-trigger-popup]').on('click', function(e) {
  e.preventDefault();
  var $this = $(this),
    triggerVal = $this.data('trigger-popup');

  popupHandler(triggerVal);
});

// hide ErrorMessage
$('#common-error-message .error-message-close').click(function() {
  $(this)
    .parent()
    .addClass('hidden');
});

// hide WarningMessage
$('.message.is-warning .message-close').click(function() {
  $(this)
    .parent()
    .addClass('hidden');
});

// add Css To ErrorMessage If Breadcrumbs
if ($('.breadcrumb').length && $('#common-error-message').length) {
  $('#common-error-message')[0].style.top = '75px';
  $('#common-error-message')[0].style.marginBottom = '25px';
}

$(document).ready(function() {
  $(window).on('load resize', function() {
    $('.truncate').dotdotdot({
      ellipsis: '... ',
      wrap: 'word',
      fallbackToLetter: true,
      watch: true
    });
  });
});

// Publishes message that main content has been clicked. Used by e.g. menu to determine when to close
// open menu items.
$('.main-content').on('click', function() {
  ko.postbox.publish('maincontent', 'click');
});
// Have to do the same for the menu overlay because this covers everything when search field is active.
$('.menu-overlay').on('click', function() {
  ko.postbox.publish('maincontent', 'click');
});

// Listen to submits on forms with the post method.
$('form[method="post"]').on('submit', function() {
  $.cookie(
    'form_submitted',
    JSON.stringify({
      scroll: $(window).scrollTop(),
      url: window.location.toString()
    })
  );
});

var scrollCookie = $.cookie('form_submitted');
// Check if a cookie has been set due to a form post.
if (scrollCookie) {
  var cookie = JSON.parse(scrollCookie);
  // See if the cookie url is within the current url.
  // We only want to scroll when the post method was to the same page.
  if (window.location.toString() === cookie.url) {
    // Have to use a timeout here. Otherwise it won't scroll.
    // TODO: Find a better solution.
    window.setTimeout(function() {
      $(window).scrollTop(cookie.scroll);
    }, 1);
  }
  $.removeCookie('form_submitted');
}
